{
  "version": 1,
  "asset_id": "b59562c5-02f7-4381-b2d9-f65a5c1d3540",
  "project_id": "1e2975bf-5ed0-490a-887a-32746528c0b1",
  "url": "/__l5e/assets-v1/b59562c5-02f7-4381-b2d9-f65a5c1d3540/logo-metropoles.jpg",
  "r2_key": "a/v1/1e2975bf-5ed0-490a-887a-32746528c0b1/b59562c5-02f7-4381-b2d9-f65a5c1d3540/logo-metropoles.jpg",
  "original_filename": "logo-metropoles.jpg",
  "size": 69884,
  "content_type": "image/jpeg",
  "created_at": "2026-09-21T21:42:10Z"
}
